unit View.Unidades.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewUnidadesEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbsigla: TLabel;
    edsigla: TDBEdit;
    lbfracionaria: TLabel;
    edfracionaria: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientUnidadesGet: TXDataWebClient;
    XDataClientUnidadesDelete: TXDataWebClient;
    UnidadesDataset: TXDataWebDataSet;
    UnidadesDatasetid: TIntegerField;
    UnidadesDatasetaliado_id: TIntegerField;
    UnidadesDatasetdata_base_id: TIntegerField;
    UnidadesDatasetsigla: TStringField;
    UnidadesDatasetfracionaria: TBooleanField;
    UnidadesDatasetcodigo_interno: TIntegerField;
    UnidadesDatasetexcluido: TBooleanField;
    UnidadesDatasetinclusao: TDateTimeField;
    UnidadesDatasetalteracao: TDateTimeField;
    UnidadesDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientUnidadesGetLoad(Response: TXDataClientResponse);
    procedure XDataClientUnidadesDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientUnidadesDeleteError(Error: TXDataClientError);
    procedure UnidadesDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewUnidadesEdit: TFViewUnidadesEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewUnidadesEdit }

procedure TFViewUnidadesEdit.btSaveClick(Sender: TObject);
begin
  if UnidadesDataset.State in dsEditModes then
  begin
        UnidadesDataset.Post;
    UnidadesDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewUnidadesEdit.btDeleteClick(Sender: TObject);
begin
  if UnidadesDataset.State in dsEditModes then
    UnidadesDataset.Post;
  XDataClientUnidadesDelete.Delete(UnidadesDataset.EntitySetName,
    TJSObject(UnidadesDataset.CurrentData));
end;


class function TFViewUnidadesEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewUnidadesEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewUnidadesEdit.InsertEntity;
begin
  UnidadesDataset.Close;
  UnidadesDataset.SetJsonData('{}');
  UnidadesDataset.Open;
  UnidadesDataset.Insert;
end;

class function TFViewUnidadesEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewUnidadesEdit(AForm).FInserting := AInserting;
    TFViewUnidadesEdit(AForm).FId := AId;
    TFViewUnidadesEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewUnidadesEdit(AForm).InsertEntity
    else
      TFViewUnidadesEdit(AForm).LoadEntity;
    TFViewUnidadesEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewUnidadesEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewUnidadesEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    UnidadesDataset.Connection.Model.DefaultSchema.FindEntityType(
      UnidadesDataset.EntitySetName
    )
  );
  XDataClientUnidadesGet.Get(UnidadesDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewUnidadesEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewUnidadesEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewUnidadesEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewUnidadesEdit.XDataClientUnidadesGetLoad(Response: TXDataClientResponse);
begin
  UnidadesDataset.Close;
  UnidadesDataset.SetJsonData(Response.Result);
  UnidadesDataset.Open;
  
  UnidadesDataset.Edit;  
end;

procedure TFViewUnidadesEdit.XDataClientUnidadesDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewUnidadesEdit.XDataClientUnidadesDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewUnidadesEdit.UnidadesDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewUnidadesEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewUnidadesEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.unidades.form.message');
  lbMessage := TLabel.Create('view.unidades.form.message.label');
  btCloseMessage := TButton.Create('view.unidades.form.message.button');
  btCancel := TButton.Create('view.unidades.form.btBack');
  btSave := TButton.Create('view.unidades.form.btSave');
  btDelete := TButton.Create('view.unidades.form.btDelete');
  lbid := TLabel.Create('view.unidades.form.lbid');
  edid := TDBEdit.Create('view.unidades.form.edid');
  lbaliado_id := TLabel.Create('view.unidades.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.unidades.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.unidades.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.unidades.form.eddata_base_id');
  lbsigla := TLabel.Create('view.unidades.form.lbsigla');
  edsigla := TDBEdit.Create('view.unidades.form.edsigla');
  lbfracionaria := TLabel.Create('view.unidades.form.lbfracionaria');
  edfracionaria := TDBEdit.Create('view.unidades.form.edfracionaria');
  lbcodigo_interno := TLabel.Create('view.unidades.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.unidades.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.unidades.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.unidades.form.edexcluido');
  lbinclusao := TLabel.Create('view.unidades.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.unidades.form.edinclusao');
  lbalteracao := TLabel.Create('view.unidades.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.unidades.form.edalteracao');
  lbexclusao := TLabel.Create('view.unidades.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.unidades.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  UnidadesDataset := TXDataWebDataSet.Create(Self);
  UnidadesDatasetid := TIntegerField.Create(Self);
  UnidadesDatasetaliado_id := TIntegerField.Create(Self);
  UnidadesDatasetdata_base_id := TIntegerField.Create(Self);
  UnidadesDatasetsigla := TStringField.Create(Self);
  UnidadesDatasetfracionaria := TBooleanField.Create(Self);
  UnidadesDatasetcodigo_interno := TIntegerField.Create(Self);
  UnidadesDatasetexcluido := TBooleanField.Create(Self);
  UnidadesDatasetinclusao := TDateTimeField.Create(Self);
  UnidadesDatasetalteracao := TDateTimeField.Create(Self);
  UnidadesDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientUnidadesGet := TXDataWebClient.Create(Self);
  XDataClientUnidadesDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbsigla.BeforeLoadDFMValues;
  edsigla.BeforeLoadDFMValues;
  lbfracionaria.BeforeLoadDFMValues;
  edfracionaria.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  UnidadesDataset.BeforeLoadDFMValues;
  UnidadesDatasetid.BeforeLoadDFMValues;
  UnidadesDatasetaliado_id.BeforeLoadDFMValues;
  UnidadesDatasetdata_base_id.BeforeLoadDFMValues;
  UnidadesDatasetsigla.BeforeLoadDFMValues;
  UnidadesDatasetfracionaria.BeforeLoadDFMValues;
  UnidadesDatasetcodigo_interno.BeforeLoadDFMValues;
  UnidadesDatasetexcluido.BeforeLoadDFMValues;
  UnidadesDatasetinclusao.BeforeLoadDFMValues;
  UnidadesDatasetalteracao.BeforeLoadDFMValues;
  UnidadesDatasetexclusao.BeforeLoadDFMValues;
  XDataClientUnidadesGet.BeforeLoadDFMValues;
  XDataClientUnidadesDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewUnidadesEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 535;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 475;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 475;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 475;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbsigla.SetParentComponent(Self);
    lbsigla.Name := 'lbsigla';
    lbsigla.Left := 24;
    lbsigla.Top := 273;
    lbsigla.Width := 14;
    lbsigla.Height := 13;
    lbsigla.Caption := 'sigla:';
    lbsigla.Transparent := True;
    edsigla.SetParentComponent(Self);
    edsigla.Name := 'edsigla';
    edsigla.Left := 221;
    edsigla.Top := 270;
    edsigla.Width := 200;
    edsigla.Height := 21;
    edsigla.Enabled := True;
    edsigla.TabOrder := 9;
    edsigla.Text := 'edsigla';
    edsigla.DataField := 'sigla';
    edsigla.DataSource := DataSource;
    lbfracionaria.SetParentComponent(Self);
    lbfracionaria.Name := 'lbfracionaria';
    lbfracionaria.Left := 24;
    lbfracionaria.Top := 300;
    lbfracionaria.Width := 14;
    lbfracionaria.Height := 13;
    lbfracionaria.Caption := 'fracionaria:';
    lbfracionaria.Transparent := True;
    edfracionaria.SetParentComponent(Self);
    edfracionaria.Name := 'edfracionaria';
    edfracionaria.Left := 221;
    edfracionaria.Top := 297;
    edfracionaria.Width := 200;
    edfracionaria.Height := 21;
    edfracionaria.Enabled := True;
    edfracionaria.TabOrder := 10;
    edfracionaria.Text := 'edfracionaria';
    edfracionaria.DataField := 'fracionaria';
    edfracionaria.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 327;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 324;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 11;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 354;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 351;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 12;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 381;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 378;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 13;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 408;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 405;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 14;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 435;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 432;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 15;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := UnidadesDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    UnidadesDataset.SetParentComponent(Self);
    UnidadesDataset.Name := 'UnidadesDataset';
    UnidadesDataset.AfterApplyUpdates := UnidadesDatasetAfterApplyUpdates;
    UnidadesDataset.EntitySetName := 'Unidades';
    UnidadesDataset.Connection := DMConnection.ApiConnection;
    UnidadesDataset.Left := 176;
    UnidadesDataset.Top := 8;
    UnidadesDatasetid.SetParentComponent(UnidadesDataset);
    UnidadesDatasetid.Name := 'UnidadesDatasetid';
    UnidadesDatasetid.FieldName := 'id';
    UnidadesDatasetid.Required := True;
    UnidadesDatasetaliado_id.SetParentComponent(UnidadesDataset);
    UnidadesDatasetaliado_id.Name := 'UnidadesDatasetaliado_id';
    UnidadesDatasetaliado_id.FieldName := 'aliado_id';
    UnidadesDatasetaliado_id.Required := True;
    UnidadesDatasetdata_base_id.SetParentComponent(UnidadesDataset);
    UnidadesDatasetdata_base_id.Name := 'UnidadesDatasetdata_base_id';
    UnidadesDatasetdata_base_id.FieldName := 'data_base_id';
    UnidadesDatasetdata_base_id.Required := True;
    UnidadesDatasetsigla.SetParentComponent(UnidadesDataset);
    UnidadesDatasetsigla.Name := 'UnidadesDatasetsigla';
    UnidadesDatasetsigla.FieldName := 'sigla';
    UnidadesDatasetsigla.Required := True;
    UnidadesDatasetsigla.Size := 255;
    UnidadesDatasetfracionaria.SetParentComponent(UnidadesDataset);
    UnidadesDatasetfracionaria.Name := 'UnidadesDatasetfracionaria';
    UnidadesDatasetfracionaria.FieldName := 'fracionaria';
    UnidadesDatasetfracionaria.Required := False;
    UnidadesDatasetcodigo_interno.SetParentComponent(UnidadesDataset);
    UnidadesDatasetcodigo_interno.Name := 'UnidadesDatasetcodigo_interno';
    UnidadesDatasetcodigo_interno.FieldName := 'codigo_interno';
    UnidadesDatasetcodigo_interno.Required := True;
    UnidadesDatasetexcluido.SetParentComponent(UnidadesDataset);
    UnidadesDatasetexcluido.Name := 'UnidadesDatasetexcluido';
    UnidadesDatasetexcluido.FieldName := 'excluido';
    UnidadesDatasetexcluido.Required := False;
    UnidadesDatasetinclusao.SetParentComponent(UnidadesDataset);
    UnidadesDatasetinclusao.Name := 'UnidadesDatasetinclusao';
    UnidadesDatasetinclusao.FieldName := 'inclusao';
    UnidadesDatasetinclusao.Required := False;
    UnidadesDatasetalteracao.SetParentComponent(UnidadesDataset);
    UnidadesDatasetalteracao.Name := 'UnidadesDatasetalteracao';
    UnidadesDatasetalteracao.FieldName := 'alteracao';
    UnidadesDatasetalteracao.Required := False;
    UnidadesDatasetexclusao.SetParentComponent(UnidadesDataset);
    UnidadesDatasetexclusao.Name := 'UnidadesDatasetexclusao';
    UnidadesDatasetexclusao.FieldName := 'exclusao';
    UnidadesDatasetexclusao.Required := False;
    XDataClientUnidadesGet.SetParentComponent(Self);
    XDataClientUnidadesGet.Name := 'XDataClientUnidadesGet';
    XDataClientUnidadesGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientUnidadesGet, Self, 'OnLoad', 'XDataClientUnidadesGetLoad');
    XDataClientUnidadesGet.Left := 64;
    XDataClientUnidadesGet.Top := 8;
    XDataClientUnidadesDelete.SetParentComponent(Self);
    XDataClientUnidadesDelete.Name := 'XDataClientUnidadesDelete';
    XDataClientUnidadesDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientUnidadesDelete, Self, 'OnLoad', 'XDataClientUnidadesDeleteLoad');
    SetEvent(XDataClientUnidadesDelete, Self, 'OnError', 'XDataClientUnidadesDeleteError');
    XDataClientUnidadesDelete.Left := 64;
    XDataClientUnidadesDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbsigla.AfterLoadDFMValues;
    edsigla.AfterLoadDFMValues;
    lbfracionaria.AfterLoadDFMValues;
    edfracionaria.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    UnidadesDataset.AfterLoadDFMValues;
    UnidadesDatasetid.AfterLoadDFMValues;
    UnidadesDatasetaliado_id.AfterLoadDFMValues;
    UnidadesDatasetdata_base_id.AfterLoadDFMValues;
    UnidadesDatasetsigla.AfterLoadDFMValues;
    UnidadesDatasetfracionaria.AfterLoadDFMValues;
    UnidadesDatasetcodigo_interno.AfterLoadDFMValues;
    UnidadesDatasetexcluido.AfterLoadDFMValues;
    UnidadesDatasetinclusao.AfterLoadDFMValues;
    UnidadesDatasetalteracao.AfterLoadDFMValues;
    UnidadesDatasetexclusao.AfterLoadDFMValues;
    XDataClientUnidadesGet.AfterLoadDFMValues;
    XDataClientUnidadesDelete.AfterLoadDFMValues;
  end;
end;

end.
